import clsx from 'clsx';
import tw from 'twin.macro';
import { Link, useLocation } from 'react-router-dom';
import { Fragment } from 'react';

import ArrowRightOnTrayIcon from '~/shared/assets/icons/arrow-right-on-tray.svg';
import DatafyLogo from '~/shared/assets/icons/datafy-logo.svg';
import Typography from '~/shared/components/Typography';
import { logout } from '~/shared/utils/logout';

import { sidebarItems, SidebarItemType } from './common';

export default function Sidebar() {
  return (
    <Root>
      <div className="flex-1">
        <DatafyLogo className="mb-[39px]" />

        <div className="flex flex-col gap-[20px]">
          {sidebarItems.map((item, i) => (
            <Fragment key={`${item.pathname}_${i}`}>
              <SidebarItem
                {...{
                  ...item,
                  icon: {
                    ...item.icon,
                    colorMode: item.icon.colorMode || 'fill',
                  },
                }}
              />
              {item.pathname === '/optimization' ? (
                <div className="w-full h-[1px] bg-primary-70"></div>
              ) : null}
            </Fragment>
          ))}
        </div>
      </div>

      <button className="h-[48px] flex items-center" onClick={logout}>
        <ArrowRightOnTrayIcon className="w-[24px] m-4 aspect-square stroke-primary-900" />
        <Typography variant="base">Log out</Typography>
      </button>
    </Root>
  );
}

const Root = tw.div`w-[290px] min-w-[290px] bg-white overflow-hidden px-[20px] pt-[30px] pb-[16px] flex flex-col`;

function SidebarItem({
  pathname: itemPathname,
  title,
  icon: { el: Icon, colorMode },
  isDisabed,
}: SidebarItemType) {
  const { pathname } = useLocation();
  const isActive = pathname === itemPathname;

  return (
    <Link
      to={itemPathname}
      className={clsx(
        'h-[48px] px-[10px] gap-[12px] items-center rounded-[8px] flex group',
        isActive ? 'bg-azure' : 'hover:bg-primary-50',
        {
          'opacity-30 pointer-events-none': isDisabed,
        }
      )}
    >
      <Icon
        className={clsx(
          'w-[20px] aspect-square',
          isActive
            ? colorMode === 'fill'
              ? 'fill-white'
              : 'stroke-white'
            : colorMode === 'fill'
              ? 'fill-primary-900 group-hover:fill-primary-400'
              : 'stroke-primary-900 group-hover:stroke-primary-400'
        )}
      />
      <Typography
        variant="p3"
        className={!isActive ? 'group-hover:text-primary-400' : undefined}
        color={isActive ? 'text-white' : undefined}
      >
        {title}
      </Typography>
    </Link>
  );
}
